import * as i0 from '@angular/core';
import { Component, Input, ViewChild, NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class EquisStickerAnimationComponent {
    constructor() {
        this.autoPlay = false;
        this.loop = false;
    }
    set width(value) {
        this._width = value ? `${value}px` : '100%';
    }
    set height(value) {
        this._height = value ? `${value}px` : '100%';
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    ngOnInit() {
        this.animation = lottie.loadAnimation({
            container: this.container.nativeElement,
            renderer: 'svg',
            loop: this.loop,
            autoplay: this.autoPlay,
            path: this.path,
        });
    }
    setQuality(quality) {
        lottie.setQuality(quality);
    }
    play() {
        this.animation.play();
    }
    stop() {
        this.animation.stop();
    }
    pause() {
        this.animation.pause();
    }
    ngOnDestroy() {
        if (this.animation) {
            this.animation.destroy();
        }
    }
}
EquisStickerAnimationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStickerAnimationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisStickerAnimationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisStickerAnimationComponent, selector: "z-sticker-animation, equis-sticker-animation", inputs: { autoPlay: "autoPlay", loop: "loop", path: "path", width: "width", height: "height" }, viewQueries: [{ propertyName: "container", first: true, predicate: ["container"], descendants: true, static: true }], ngImport: i0, template: "<div\n  #container\n  [ngStyle]=\"{ width: width, height: height }\"\n  class=\"sticker\"\n></div>\n", dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStickerAnimationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-sticker-animation, equis-sticker-animation', template: "<div\n  #container\n  [ngStyle]=\"{ width: width, height: height }\"\n  class=\"sticker\"\n></div>\n" }]
        }], propDecorators: { autoPlay: [{
                type: Input
            }], loop: [{
                type: Input
            }], path: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], container: [{
                type: ViewChild,
                args: ['container', { static: true }]
            }] } });

class EquisStickerAnimationModule {
    static forRoot() {
        return {
            ngModule: EquisStickerAnimationModule,
        };
    }
}
EquisStickerAnimationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStickerAnimationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisStickerAnimationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisStickerAnimationModule, declarations: [EquisStickerAnimationComponent], imports: [CommonModule], exports: [EquisStickerAnimationComponent] });
EquisStickerAnimationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStickerAnimationModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisStickerAnimationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisStickerAnimationComponent],
                    imports: [CommonModule],
                    exports: [EquisStickerAnimationComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EquisStickerAnimationComponent, EquisStickerAnimationModule };
